import { HttpClient } from "@angular/common/http";
import { environment } from "@environments/environment";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { OAuthStorage } from "angular-oauth2-oidc";

@Injectable({
  providedIn: "any",
})
export class AuthHttpClientService {
  constructor(
    private readonly http: HttpClient,
    private readonly oauth: OAuthStorage,
  ) {}

  get<T>(url: string): Observable<T> {
    return this.http.get<T>(url, {
      headers: {Authorization: `Bearer ${this.oauth.getItem(environment.sso.tokenType)}`},
    });
  }

  post<T>(url: string, body?: unknown): Observable<T> {
    return this.http.post<T>(url, body, {
      headers: {Authorization: `Bearer ${this.oauth.getItem(environment.sso.tokenType)}`, 'Content-Type': 'application/json'},
    });
  }

  put<T>(url: string, body?: unknown): Observable<T> {
    return this.http.put<T>(url, body, {
      headers: {Authorization: `Bearer ${this.oauth.getItem(environment.sso.tokenType)}`, 'Content-Type': 'application/json'},
    });
  }

  delete<T>(url: string): Observable<T> {
    return this.http.delete<T>(url, {
      headers: {Authorization: `Bearer ${this.oauth.getItem(environment.sso.tokenType)}`},
    });
  }
}
